<div *ngIf="auctionTicketRules$ | async">
  <nz-collapse>
    <nz-collapse-panel nzHeader="{{ 'TICKET_RULES' | translate }}">
      <div [innerHTML]="auctionTicketRules$ | async"></div>
    </nz-collapse-panel>
  </nz-collapse>
</div>
